<template>
  <v-app light :class="$route.name">

    <main>
      <router-view></router-view>
    </main>

  </v-app>
</template>

<script>
  // import Vue from 'vue'

  export default {
    data () {
      return {
        title: 'Vivid Arts Pro Artist'
      }
    },
    watch: { },
    computed: { }
  }
</script>

<style lang="stylus">
  @import './stylus/main'
  .list__tile > a {
    width: 100%;
    height: 100%;
  }
  .list__tile > a > div {
    float: left;
  }
</style>



// WEBPACK FOOTER //
// App.vue?0fe1dc00